import React from 'react';
import './IdeaStatusBadge.css';
import { IDEA_STATUSES } from '../../../constants/ideaWorkflow';

const STATUS_META = {
  [IDEA_STATUSES.DRAFT]:        { label: 'Draft',        icon: '✏️' },
  [IDEA_STATUSES.SUBMITTED]:    { label: 'Submitted',    icon: '📤' },
  [IDEA_STATUSES.UNDER_REVIEW]: { label: 'Under Review', icon: '🔍' },
  [IDEA_STATUSES.SHORTLISTED]:  { label: 'Shortlisted',  icon: '✅' },
  [IDEA_STATUSES.APPROVED]:     { label: 'Approved',     icon: '🎉' },
  [IDEA_STATUSES.CLOSED]:       { label: 'Closed',       icon: '🚫' },
  [IDEA_STATUSES.SENT_BACK]:    { label: 'Sent Back',    icon: '↩️' },
  [IDEA_STATUSES.ROCK_TUMBLER]: { label: 'Rock-Tumbler', icon: '🪨' },
  [IDEA_STATUSES.LEGACY]:       { label: 'Legacy',       icon: '🗂️' },
};

function IdeaStatusBadge({ status }) {
  const meta = STATUS_META[status] || { label: status || 'Unknown', icon: '❓' };
  const cssKey = `status-${(status || 'draft').toLowerCase()}`;
  return (
    <span className={`idea-status-badge ${cssKey}`}>
      {meta.icon} {meta.label}
    </span>
  );
}

export default IdeaStatusBadge;
